import FancyMarket from './FancyMarket'

/**
 * Normal market (mname === "Normal") — reference `.market-6` fancy block.
 */
function Normal({ onBetLockClick, marketsData = [], exposureData = {}, index }) {
  return (
    <FancyMarket
      marketName="Normal"
      betLockName="Normal"
      layout="noyes"
      index={index ?? 1}
      onBetLockClick={onBetLockClick}
      marketsData={marketsData}
      exposureData={exposureData}
    />
  )
}

export default Normal
